export default "__VITE_ASSET__189838f6__"